module.exports = __webpack_public_path__ + "images/sprites/ui/btn_logo_line_949029f1eb42d9724e7694442f3cd376.png";